<template>
  <div class="ext" :class="{ 'histogram-wrap': isMobile }" ref="wrap">
    <div id="histogramChart" class="histogram-chart" :style="chartBoxStyle"></div>
  </div>
</template>
<script>
export default {
  props: {
    hDataArrs: {
      type: Array,
      default: () => []
    },
    isMobile: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      xDataArr: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31],
      yDataArr: []
    }
  },
  computed: {
    chartBoxStyle () {
      if (!this.isMobile) {
        return { width: '100%', height: '245px' }
      }
      return { width: '100%', height: 'clamp(280px, 60vw, 300px)' }
    }
  },
  created () {
    console.log(this.hDataArrs, '这是按日份的数据')
    this.yDataArr = this.hDataArrs || []
  },
  mounted () {
    this.drawLine()
    window.addEventListener('resize', this.onResize, { passive: true })
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onResize)
    const el = document.getElementById('histogramChart')
    if (el) {
      const c = this.$echarts.getInstanceByDom(el)
      if (c) c.dispose()
    }
  },
  watch: {
    hDataArrs: {
      handler (v) {
        this.yDataArr = v || []
        this.$nextTick(() => this.drawLine())
      },
      deep: true
    },
    isMobile () {
      this.$nextTick(() => this.drawLine())
    },
    '$i18n.locale': {
      handler () {
        this.drawLine()
      }
    }
  },
  methods: {
    onResize () {
      const el = document.getElementById('histogramChart')
      if (!el) return
      const chart = this.$echarts.getInstanceByDom(el)
      if (chart) chart.resize()
    },
    /** 手机端：随屏宽调整柱宽与网格 */
    computeBarLayoutMobile () {
  const el = document.getElementById('histogramChart')
  const cw = (el && el.clientWidth) || (this.$refs.wrap && this.$refs.wrap.clientWidth) || 320
  const n = Math.max(this.xDataArr.length, 1)
  
  // 1. 缩小左右边距 (由 0.1 改为 0.05)，释放更多横向空间
  const gridLR = 0.05 
  
  const plotW = cw * (1 - gridLR * 2)
  const slot = plotW / n
  
  // 2. 加大柱宽比例和上限 (由 max 12 改为 max 14)
  let barPx = Math.round(slot * 0.45)
  barPx = Math.max(6, Math.min(barPx, 14))
  
  return {
    barPx,
    bottomPct: '25%', // 稍微增加底部空间，防止 x 轴文字被截断
    labelFont: 10, // 字体稍微调大一点
    rotate: n > 15 ? 45 : 0, // 31个日期时角度调大，避免重叠
    gridLR
  }
},
    drawLineDesktop () {
      const myChart = this.$echarts.init(document.getElementById('histogramChart'))
      const _this = this
      myChart.setOption({
        title: { text: '' },
        tooltip: {
          trigger: 'axis',
          formatter: (arg) => {
            return arg[0].name + _this.$t('chart.号的数据是：') + arg[0].data
          }
        },
        grid: {
          top: '10%',
          right: '5%',
          bottom: '15%'
        },
        xAxis: {
          data: this.xDataArr
        },
        yAxis: {
          type: 'value',
          axisLine: {}
        },
        series: [{
          name: _this.$t('chart.用水'),
          type: 'bar',
          data: this.yDataArr,
          itemStyle: {
            barWidth: 10,
            color: '#744DFE',
            barBorderRadius: 20
          },
          barWidth: 10
        }]
      })
    },
    drawLineMobile () {
      const el = document.getElementById('histogramChart')
      if (!el) return
      let chart = this.$echarts.getInstanceByDom(el)
      if (!chart) {
        chart = this.$echarts.init(el)
      }
      const _this = this
      const { barPx, bottomPct, labelFont, rotate, gridLR } = this.computeBarLayoutMobile()
      chart.setOption({
        title: { text: '' },
        tooltip: {
          trigger: 'axis',
          formatter: (arg) => {
            if (!arg || !arg[0]) return ''
            return arg[0].name + _this.$t('chart.号的数据是：') + arg[0].data
          }
        },
        grid: {
          top: '12%',
          left: `${gridLR * 100}%`,
          right: `${gridLR * 100}%`,
          bottom: bottomPct,
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: this.xDataArr,
          axisLabel: {
            fontSize: labelFont,
            rotate,
            interval: 0
          }
        },
        yAxis: {
          type: 'value',
          axisLabel: { fontSize: labelFont }
        },
        series: [{
          name: _this.$t('chart.用水'),
          type: 'bar',
          data: this.yDataArr,
          barWidth: barPx,
          barMaxWidth: barPx + 4,
          itemStyle: {
            color: '#744DFE',
            barBorderRadius: 8
          }
        }]
      }, true)
      chart.resize()
    },
    drawLine () {
      this.$nextTick(() => {
        const el = document.getElementById('histogramChart')
        if (!el) return
        const existing = this.$echarts.getInstanceByDom(el)
        if (existing) {
          existing.dispose()
        }
        if (this.isMobile) {
          this.drawLineMobile()
        } else {
          this.drawLineDesktop()
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.ext {
  width: 100%;
}
.histogram-wrap {
  min-width: 0;
}
.histogram-chart {
  min-height: 0;
}
.histogram-wrap .histogram-chart {
  min-height: 200px;
}
</style>
